// Os idiomas que um widget pode servir, num sítio só. A secção Idioma escolhe-os
// e os separadores da Copy nomeiam-nos: com a lista escrita duas vezes, juntar um
// idioma a uma delas dava um separador com "it" no cimo, ou um idioma que nunca
// chegava a ter separador.
export const WIDGET_LOCALES = [
  { value: "pt", label: "Português" },
  { value: "en", label: "English" },
  { value: "fr", label: "Français" },
  { value: "es", label: "Español" },
  { value: "de", label: "Deutsch" },
  { value: "it", label: "Italiano" },
];

// Os nomes não passam pelo translate de propósito: um idioma diz-se no seu
// próprio idioma, seja qual for aquele em que o backoffice está.
export const localeLabel = (value) =>
  WIDGET_LOCALES.find((l) => l.value === value)?.label || value;

// Os separadores da copy, pela ordem em que aparecem: o idioma por omissão
// primeiro e os outros a seguir. Vive aqui porque quem os desenha (o
// CopySection) e quem legenda a pré-visualização (a WidgetSettingsPage) têm de
// concordar sobre que separadores existem — com a regra escrita duas vezes, a
// legenda podia nomear um separador que já não está no ecrã.
export const copyLocaleTabs = (defaultLocale, locales) => {
  const base = defaultLocale || "pt";
  return [base, ...(locales || []).filter((l) => l !== base)];
};
